import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            valor: 0,
            uvt_id: null,
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    setData(data) {
        this.setState({
            valor: data.valor,
            uvt_id: data.uvt_id,
        })
    }


    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.coeficientesgc.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Coeficiente GC"}
                buttonTitle={"Ver Coeficiente GC"}
                buttonIcon={"fa fa-search fa-lg"}

                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setData(data)}

            >
                <ParadigmaLabeledInput label="UVT" labelColumns={2} fieldColumns={10}
                    inputComponent={<ParadigmaAsyncSeeker disabled fieldName={"uvt_id"} url={api.proyectos.config.presupuesto.uvt.select}
                        onChange={(e) => this.setState({ uvt_id: e.pk })} value={this.state.uvt_id} />}
                />
                <ParadigmaLabeledInput disabled fieldName="nombre" label="Nombre" labelColumns={2} fieldColumns={10} />
                <ParadigmaLabeledInput disabled type={"number"} fieldName="valor" label="Valor" labelColumns={2} fieldColumns={10} />
                <ParadigmaLabeledInput disabled type={"textarea"} fieldName="descripcion" label="Descripción" labelColumns={12} fieldColumns={12} />
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_CoeficientesGC/Detail.js